import React, { useState, useRef } from 'react';

import Modal from 'react-bootstrap/Modal';
import { FaEdit } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { toast } from 'react-toastify';
import { format, subYears, addDays, isValid } from 'date-fns';
import Bunexe_service from '../../../Bunexe_service';

const EditNotes = ({ infoEleve, myheader, reload_List }) => {
  const nomref = useRef();
  const [show, setShow] = useState(false);
  const [moyns4, setMoyns4] = useState(infoEleve.moy);
  const [note_ns3, setNote_ns3] = useState(infoEleve.note);
  const [serie, setSerie] = useState(infoEleve.serie);
  let url_ = Bunexe_service.url;
  //'http://localhost:8086';
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const submitform = (e) => {
    e.preventDefault();

    //console.log(`username ${username} et password:${password}`);
    let mydata = {
      an9AF: infoEleve.an9AF,
      mat9AF: infoEleve.mat9AF,
      id: infoEleve.id,
      serie: serie,
      note: note_ns3,
    };
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(mydata),
    };
    try {
      fetch(url_ + `/ns3_notes/edit_eleve/${mydata.id}`, requestOptions)
        .then((response) => {
          return response.json();
          //else throw Error(response.statusText);
        })
        .then((data) => {
          if (data.hasError) {
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            //afficherMessage(data.message);
          } else {
            //  listeEleves_func(Ecole);

            reload_List();
            setShow(false);
          }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error("Erreur d'insertion ...", error);
    }
  };

  return (
    <>
      {/* <Button variant='primary' onClick={handleShow}>
        edit
      </Button> */}
      <FaEdit onClick={handleShow} />

      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Modification (NS-I) ou Troisième Secondaire</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='container mx-auto'>
            <div className='row'>
              <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 border rounded py-2'>
                <h2 className='text-center'>{myheader.LibelleEt}</h2>
                <h4 className='text-center'>{myheader.AdresseEt}</h4>
                <h6 className='text-center'>{myheader.Ecole}</h6>
                <hr />
                <h6>
                  Identifiant :
                  <span className='font-weight-bold font-italic'>
                    {infoEleve.IDENTIFIANT}
                  </span>
                </h6>
                <h6>
                  <span>Nom :</span>
                  <span className='ml-1 font-weight-bold font-italic'>
                    {infoEleve.NOMEL}
                  </span>
                  <span className='ml-5'>Prenom :</span>
                  <span className='ml-1 font-weight-bold font-italic'>
                    {infoEleve.PRENOMEL}
                  </span>
                </h6>
                <h6>Sexe :{infoEleve.SEXE == '1' ? 'M' : 'F'}</h6>
                <h6>
                  Date Naissance :
                  <span className='ml-1 font-weight-bold font-italic'>
                    {format(
                      addDays(
                        new Date(
                          infoEleve.DNAISS.substr(0, 4)
                            .concat('-')
                            .concat(infoEleve.DNAISS.substr(4, 2))
                            .concat('-')
                            .concat(infoEleve.DNAISS.substr(6, 2))
                        ),
                        1
                      ),
                      'dd/MM/yyyy'
                    )}
                  </span>
                </h6>
                <hr />
                <Form autoComplete='off' noValidate onSubmit={submitform}>
                  <Form.Row>
                    <Form.Group as={Col} controlId='formSerie'>
                      <Form.Label>Serie</Form.Label>
                      <Form.Control
                        as='select'
                        value={serie}
                        onChange={(e) => {
                          setSerie(e.target.value);
                        }}
                      >
                        {Bunexe_service.serie.map((s) => (
                          <option value={s.Code_serie}>{s.Libelle}</option>
                        ))}
                        {/* <option value='M'>Masculin</option> */}
                        {/* <option value='F'>Feminin</option> */}
                      </Form.Control>
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId='formGridPrenom'>
                      <Form.Label>Note Français NS-III</Form.Label>
                      <Form.Control
                        type='number'
                        placeholder='Note '
                        value={note_ns3}
                        max='99'
                        name='note_ns3'
                        onChange={(e) => setNote_ns3(e.target.value)}
                      />
                    </Form.Group>
                  </Form.Row>

                  {/* <Form.Row>
                    <Form.Group as={Col} controlId='formGridPrenom'>
                      <Form.Label>
                        Moyenne NS I ou Troisième Secondaire
                      </Form.Label>
                      <Form.Control
                        type='number'
                        placeholder='Moyenne'
                        value={moyns4}
                        max='9.99'
                        name='moyns4'
                        onChange={(e) => setMoyns4(e.target.value)}
                      />
                    </Form.Group>
                  </Form.Row>
                */}
                </Form>
                <hr />
                {/* {message && message.length > 0 && <small>{message}</small>} */}
              </div>
            </div>
          </div>
          {/* Woohoo, you're reading this text in a modal! */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Fermer
          </Button>
          <Button variant='primary' onClick={submitform}>
            Modifier
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditNotes;
